import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Button from '@eig-builder/core-ui/Button'
import { PropertyEditor, Field } from '@eig-builder/module-property-editor'
import TextField from '@eig-builder/core-ui/TextField'

import { DataElementLocations } from '@eig-builder/core-utils/helpers/tagging-helper'

import ButtonWithLoader from 'core/components/button-with-loader'
import Modal from 'core/components/modal'

import ChangeEmailSchema from './schema/change-email.json'

import Text from '@eig-builder/module-localization'

const styles = theme => ({
  bold: {
    fontWeight: 600
  },
  field: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2)
  },
  actions: {
    margin: theme.spacing(5),
    marginTop: 0
  },
  loader: {
    verticalAlign: 'middle'
  }
})

const ChangeEmail = props => {
  const { account, classes, open, pending } = props

  const propertyEditorRef = useRef()

  const triggerSubmit = () => propertyEditorRef.current.validate() && propertyEditorRef.current.submit()

  const handleSubmit = values => {
    props.changeAccountEmail(props.account.partnerId, props.account.id, values)
  }

  if (!account) {
    return null
  }

  const actions = [
    <Button
      key='cancel-change-email'
      color='secondary'
      disabled={pending}
      onClick={props.handleDialog}
      dataElementLocation={DataElementLocations.BODY}
      dataElementLabel='cst-account-details-change-email-cancel'
      dataElementId='cst-account-details-change-email-cancel'
    >
      <Text message='modules.crm.components.account.cancel' />
    </Button>,
    <ButtonWithLoader
      key='submit-change-email'
      type='submit'
      disabled={pending}
      onClick={triggerSubmit}
      dataElementSuffix='account-details--change-email-submit'
      showLoader={pending}
      text={<Text message='modules.crm.components.account.submit' />}
    />
  ]

  return (
    <PropertyEditor
      ref={propertyEditorRef}
      schema={ChangeEmailSchema}
      onSubmit={handleSubmit}
      generateFields={false}
      dataElementLocation={DataElementLocations.BODY}
      dataElementLabelPrefix='cst-account--change-email'
      dataElementIdPrefix='cst-account--change-email'
    >
      <Modal
        actions={actions}
        dataElementPrefix='cst-account--change-email'
        disableBackdropClick
        handleClose={props.handleDialog}
        open={open}
        title={<Text message='modules.crm.components.account.changeEmail.title' />}
      >

        <div>
          <Text className={classes.bold} message='modules.crm.components.account.changeEmail.warning' /> -{' '}
          <Text message='modules.crm.components.account.changeEmail.warningInfo' />
        </div>
        <div>
          <Text message='modules.crm.components.account.changeEmail.info' />
        </div>
        <div>
          <Text className={classes.bold} message='modules.crm.components.account.changeEmail.note' /> -{' '}
          <Text message='modules.crm.components.account.changeEmail.noteInfo' />
        </div>
        <TextField
          fullWidth
          className={classes.field}
          label='Current email address'
          value={account.emailAdress}
          InputProps={{
            readOnly: true
          }}
          variant='outlined'
          dataElementLocation={DataElementLocations.BODY}
          dataElementLabel='cst-account-details-change-email-current'
          dataElementId='cst-account-details-change-email-current'
        />
        <Field
          noCol12
          name='email'
          dataElementLocation={DataElementLocations.BODY}
          dataElementLabel='cst-account-details-change-email--email'
          dataElementId='cst-account-details-change-email--email'
        />
      </Modal>
    </PropertyEditor>
  )
}

ChangeEmail.propTypes = {
  account: PropTypes.object.isRequired,
  changeAccountEmail: PropTypes.func.isRequired,
  handleDialog: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  pending: PropTypes.bool
}

export default withStyles(styles)(ChangeEmail)
